module.exports = __webpack_public_path__ + "assets/img/71.00c78980.png";